import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import RoleForm from "./RoleForm";
import { useGetRoleByIdQuery, useUpdateRoleMutation } from "../../redux/api/rolesApi";

const EditRolePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const { data: role, isLoading, error } = useGetRoleByIdQuery(id);
  const [updateRole, { isLoading: isUpdating }] = useUpdateRoleMutation();

  const handleSubmit = async (formData) => {
    try {
      await updateRole({ ...formData, role_id: id }).unwrap();
      toast.success('Role updated successfully');
      navigate('/admin/roles');
    } catch (err) {
      toast.error(err?.data?.message || err?.error || 'Failed to update role');
    }
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div className="alert alert-danger">{error?.data?.message || error?.error || 'Failed to load role'}</div>;
  if (!role) return <div>Role not found</div>;

  return (
    <div>
      <h1 className="mb-4">Edit Role</h1>
      <RoleForm role={role} onSubmit={handleSubmit} loading={isUpdating} />
    </div>
  );
};

export default EditRolePage;
